import Color from '@/Enums/Color.enum';
import DateFormat from '@/Enums/Format/DateFormat.enum';
import { Box, Button, OutlinedInput, Stack } from '@mui/material';
import { PickersActionBarProps } from '@mui/x-date-pickers';
import { DateRange } from '@mui/x-date-pickers-pro';
import moment, { Moment } from 'moment';
import { useMemo } from 'react';

const getDisplayedValue = (value?: Moment | string | null): string =>
  value ? moment(value).format(DateFormat.NumericMonthDayYear) : '';

interface IProps extends PickersActionBarProps {
  value?: DateRange<Moment>;
  className?: string;
  onRangeChange?: (next: DateRange<Moment>) => void;
}

const ActionBar = ({ onAccept, onCancel, value, className }: IProps) => {
  const startValue = value?.[0] ?? null;
  const endValue = value?.[1] ?? null;

  const startPlaceholder = useMemo(() => DateFormat.NumericMonthDayYear, []);
  const endPlaceholder = useMemo(() => DateFormat.NumericMonthDayYear, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTopWidth: '1px',
        borderTopColor: Color.GreyBorder,
        padding: '16px',
      }}
      className={className}
    >
      <Stack
        spacing='16px'
        direction='row'
        divider={<p className='leading-[2.7]'>—</p>}
        sx={{
          width: 350,
          height: 40,
        }}
      >
        <Stack
          direction='row'
          spacing='8px'
          sx={{
            alignItems: 'center',
            height: 40,
          }}
        >
          <OutlinedInput readOnly value={getDisplayedValue(startValue)} placeholder={startPlaceholder} />
        </Stack>
        <Stack
          direction='row'
          spacing='8px'
          sx={{
            alignItems: 'center',
            height: 40,
          }}
        >
          <OutlinedInput readOnly value={getDisplayedValue(endValue)} placeholder={endPlaceholder} />
        </Stack>
      </Stack>
      <Stack
        spacing='8px'
        direction='row'
        sx={{
          height: 40,
        }}
      >
        <Button variant='outlined' onClick={onCancel}>
          Cancel
        </Button>
        <Button variant='contained' onClick={onAccept} disabled={value?.some(v => !v)}>
          Apply
        </Button>
      </Stack>
    </Box>
  );
};
export default ActionBar;
